<div class="inspecao-tab-container">

  <!-- ── 1. BLOCO DE ÚLTIMA INSPEÇÃO ── -->
  <div class="inspecao-summary-card ultima-inspecao-card" [ngClass]="getResultadoClass(ultimaInspecao?.resultado)">
    <div class="card-icon-wrap">
      <i class="ri-checkbox-circle-line" *ngIf="ultimaInspecao?.resultado === 'Aprovado'"></i>
      <i class="ri-error-warning-line" *ngIf="ultimaInspecao?.resultado === 'Com Observações'"></i>
      <i class="ri-close-circle-line" *ngIf="ultimaInspecao?.resultado === 'Reprovado'"></i>
      <i class="ri-shield-check-line" *ngIf="!ultimaInspecao"></i>
    </div>
    <div class="card-content">
      <div class="card-title" *ngIf="ultimaInspecao">
        Última inspeção: <strong>{{ formatDate(ultimaInspecao.data) }}</strong>
        <span class="card-time" *ngIf="ultimaInspecao.hora"><i class="ri-time-line"></i> {{ ultimaInspecao.hora }}</span>
      </div>
      <div class="card-title" *ngIf="!ultimaInspecao">
        Última inspeção: <strong>Nenhuma inspeção registada</strong>
      </div>
      <div class="card-subtitle" *ngIf="ultimaInspecao">
        Resultado: <span class="res-highlight">{{ ultimaInspecao.resultado | lowercase }}</span> &middot; verificado por <strong>{{ ultimaInspecao.responsavel }}</strong>
        <span *ngIf="ultimaInspecao.postoNome">&middot; {{ ultimaInspecao.postoNome }}</span>
      </div>
      <div class="card-subtitle" *ngIf="!ultimaInspecao">
        Efetue o registo da primeira verificação de conformidade desta arma.
      </div>
    </div>
    <div class="card-badge" *ngIf="ultimaInspecao">
      <span class="status-chip" [ngClass]="getResultadoClass(ultimaInspecao.resultado)">
        <i [class]="getResultadoIcon(ultimaInspecao.resultado)"></i>
        {{ ultimaInspecao.resultado }}
      </span>
    </div>
  </div>

  <!-- ── 2. BLOCO DE PRÓXIMA INSPEÇÃO OBRIGATÓRIA ── -->
  <div class="inspecao-summary-card proxima-inspecao-card" [class.overdue]="isProximaAtrasada">
    <div class="card-icon-wrap">
      <i class="ri-calendar-event-line"></i>
    </div>
    <div class="card-content">
      <div class="card-title">
        Próxima inspeção obrigatória: <strong>{{ formatDate(proximaInspecaoData) }}</strong>
        <span class="overdue-tag" *ngIf="isProximaAtrasada">
          <i class="ri-alarm-warning-line"></i> Atrasada
        </span>
      </div>
      <div class="card-subtitle">
        Frequência definida: <strong>{{ (ultimaInspecao?.frequenciaDefinida || frequenciaCadastro) | lowercase }}</strong>
      </div>
    </div>
    <div class="card-badge">
      <span class="freq-chip">
        <i class="ri-loop-right-line"></i> {{ ultimaInspecao?.frequenciaDefinida || frequenciaCadastro }}
      </span>
    </div>
  </div>

  <!-- ── 3. HISTÓRICO DE INSPEÇÕES (TIMELINE) ── -->
  <div class="historico-inspecoes-section">
    <div class="section-header-bar">
      <div class="header-text">
        <h3 class="section-title">Histórico de inspeções</h3>
        <p class="section-subtitle">Verificações realizadas nesta arma.</p>
      </div>
      <button type="button" class="btn-registar-inspecao" (click)="abrirDrawerRegisto()">
        <i class="ri-add-line"></i>
        <span>Registar inspeção</span>
      </button>
    </div>

    <!-- Timeline list -->
    <div class="inspecao-timeline" *ngIf="inspecoes.length > 0">
      <div
        class="timeline-item"
        *ngFor="let item of inspecoes; let i = index; let last = last"
        [class.is-last]="last"
      >
        <!-- Marker dot & connector line -->
        <div class="timeline-indicator">
          <div class="timeline-dot" [ngClass]="getResultadoClass(item.resultado)">
            <i [class]="getResultadoIcon(item.resultado)"></i>
          </div>
          <div class="timeline-line" *ngIf="!last"></div>
        </div>

        <!-- Timeline body card -->
        <div class="timeline-body">
          <div class="timeline-header-row">
            <span class="item-tipo">{{ item.tipo }}</span>
            <span class="result-badge" [ngClass]="getResultadoClass(item.resultado)">
              {{ item.resultado }}
            </span>
          </div>

          <div class="item-details-row">
            <span class="item-obs" *ngIf="item.observacoes">{{ item.observacoes }}</span>
            <span class="item-separator" *ngIf="item.observacoes && item.responsavel">&middot;</span>
            <span class="item-responsavel" *ngIf="item.responsavel">{{ item.responsavel }}</span>
            <span class="item-posto" *ngIf="item.postoNome">({{ item.postoNome }})</span>
          </div>

          <!-- Encaminhamento automático se reprovado ou com observações -->
          <div class="encaminhamento-pill" *ngIf="item.encaminhamento">
            <i class="ri-arrow-right-circle-line"></i>
            <span>Encaminhamento automático: <strong>{{ item.encaminhamento }}</strong></span>
          </div>

          <!-- Evidências fotográficas ou documentos se houver -->
          <div class="item-attachments-row" *ngIf="item.fotoGeralPreview || item.fotoDetalhePreview || item.relatorioPdfNome">
            <span class="attach-chip" *ngIf="item.fotoGeralPreview">
              <i class="ri-image-line"></i> Foto Geral
            </span>
            <span class="attach-chip" *ngIf="item.fotoDetalhePreview">
              <i class="ri-zoom-in-line"></i> Foto Detalhe
            </span>
            <span class="attach-chip pdf" *ngIf="item.relatorioPdfNome">
              <i class="ri-file-pdf-line"></i> {{ item.relatorioPdfNome }}
            </span>
          </div>

          <div class="item-date">
            <i class="ri-calendar-line"></i>
            {{ formatDate(item.data) }}
            <span *ngIf="item.hora">&middot; <i class="ri-time-line"></i> {{ item.hora }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty state -->
    <div class="timeline-empty-state" *ngIf="inspecoes.length === 0">
      <div class="empty-icon-box">
        <i class="ri-shield-check-line"></i>
      </div>
      <h4>Nenhuma inspeção registada</h4>
      <p>Ainda não foram realizadas inspeções nesta arma. Clique no botão acima para registar a primeira verificação.</p>
    </div>
  </div>

  <!-- ── 4. HISTÓRICO DE ENCAMINHAMENTOS TÉCNICOS (Se existirem) ── -->
  <div class="encaminhamentos-section" *ngIf="historicoEncaminhamentos.length > 0">
    <div class="encaminhamentos-header">
      <i class="ri-history-line"></i>
      <div>
        <h4>Histórico de Acompanhamento e Encaminhamentos</h4>
        <small>Registos automáticos gerados a partir de inspeções reprovadas ou com observações</small>
      </div>
    </div>
    <div class="encaminhamentos-list">
      <div class="encaminhamento-card" *ngFor="let enc of historicoEncaminhamentos">
        <div class="enc-dot" [ngClass]="getResultadoClass(enc.resultado)"></div>
        <div class="enc-body">
          <div class="enc-title-row">
            <span class="enc-title">{{ enc.titulo }}</span>
            <span class="enc-date">{{ formatDate(enc.data) }}</span>
          </div>
          <p class="enc-desc">{{ enc.descricao }}</p>
          <div class="enc-meta">
            <span><i class="ri-user-line"></i> {{ enc.responsavel }}</span>
            <span><i class="ri-tools-line"></i> {{ enc.encaminhamento }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- ── DRAWER DE REGISTO DE INSPEÇÃO DE ARMA ── -->
<p-drawer
  [(visible)]="drawerVisible"
  position="right"
  [modal]="true"
  [blockScroll]="true"
  styleClass="inspecao-drawer"
>
  <ng-template #header>
    <div class="drawer-header-custom">
      <div class="header-icon">
        <i class="ri-shield-check-line"></i>
      </div>
      <div>
        <h3>Registar Inspeção de Arma</h3>
        <p>Verificação periódica de conformidade e estado operacional</p>
      </div>
    </div>
  </ng-template>

  <div class="drawer-form-body">

    <!-- 1. Campo Equipamento (Arma) - Pré-preenchido e Bloqueado -->
    <div class="form-group locked-equip-group">
      <div class="locked-label-row">
        <span class="form-label"><i class="ri-focus-3-line"></i> Equipamento / Arma</span>
        <span class="locked-badge"><i class="ri-lock-2-line"></i> Contexto Bloqueado</span>
      </div>
      <div class="locked-equip-card">
        <div class="equip-icon-box">
          <i class="ri-shield-line"></i>
        </div>
        <div class="equip-info-box">
          <strong class="equip-title">{{ armaDisplayName }}</strong>
          <span class="equip-sub">{{ armaReferencia }}</span>
        </div>
      </div>
      <small class="locked-hint">O registo fica automaticamente vinculado a esta arma.</small>
    </div>

    <!-- 2. Inspecionado por (lista de responsáveis/guardas) -->
    <div class="form-group">
      <label class="form-label">Inspecionado por <span class="req">*</span></label>
      <p-select
        [options]="efetivos"
        [(ngModel)]="form.inspecionadoPor"
        [editable]="true"
        optionLabel="label"
        optionValue="value"
        placeholder="Selecione o responsável / guarda"
        styleClass="w-full"
      ></p-select>
    </div>

    <!-- 3. Data da Inspeção e Hora -->
    <div class="form-row-2">
      <div class="form-group">
        <label class="form-label">Data da Inspeção <span class="req">*</span></label>
        <p-datepicker
          [(ngModel)]="form.data"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          (ngModelChange)="onDataOrPeriodicidadeChange()"
          styleClass="w-full"
        ></p-datepicker>
      </div>
      <div class="form-group">
        <label class="form-label">Hora da Inspeção <span class="req">*</span></label>
        <div class="time-input-wrap">
          <input
            type="time"
            pInputText
            [(ngModel)]="form.hora"
            class="w-full"
          />
        </div>
      </div>
    </div>

    <!-- 4. Posto (lista de postos/unidades) -->
    <div class="form-group">
      <label class="form-label">Posto / Unidade <span class="req">*</span></label>
      <p-select
        [options]="postos"
        [(ngModel)]="form.postoId"
        optionLabel="label"
        optionValue="value"
        (onChange)="onPostoChange($event)"
        placeholder="Selecione o posto ou unidade"
        styleClass="w-full"
      ></p-select>
    </div>

    <!-- 5. Resultado da Inspeção -->
    <div class="form-group">
      <label class="form-label">Resultado <span class="req">*</span></label>
      <div class="resultado-selector-grid">
        <button
          type="button"
          class="res-select-card card-aprovado"
          [class.active]="form.resultado === 'Aprovado'"
          (click)="onResultadoChange('Aprovado')"
        >
          <i class="ri-checkbox-circle-fill"></i>
          <span class="res-title">Aprovado</span>
          <span class="res-desc">Operacional sem restrições</span>
        </button>

        <button
          type="button"
          class="res-select-card card-observacoes"
          [class.active]="form.resultado === 'Com Observações'"
          (click)="onResultadoChange('Com Observações')"
        >
          <i class="ri-error-warning-fill"></i>
          <span class="res-title">Com Observações</span>
          <span class="res-desc">Operacional com limitações</span>
        </button>

        <button
          type="button"
          class="res-select-card card-reprovado"
          [class.active]="form.resultado === 'Reprovado'"
          (click)="onResultadoChange('Reprovado')"
        >
          <i class="ri-close-circle-fill"></i>
          <span class="res-title">Reprovado</span>
          <span class="res-desc">Retirar de serviço</span>
        </button>
      </div>
    </div>

    <!-- 6. Observações e Anomalias Detectadas -->
    <div class="form-group">
      <label class="form-label">Observações e Anomalias Detectadas</label>
      <textarea
        pTextarea
        [(ngModel)]="form.observacoes"
        rows="3"
        class="w-full"
        placeholder="Texto livre: descreva anomalias detectadas, folgas, mecanismo de segurança, funcionamento, etc."
      ></textarea>
    </div>

    <!-- 7. Próxima Inspeção (Data + Periodicidade) -->
    <div class="form-group next-inspecao-box">
      <label class="form-label"><i class="ri-calendar-check-line"></i> Próxima Inspeção Obrigatória</label>
      <div class="form-row-2">
        <div class="subfield">
          <span class="subfield-label">Periodicidade</span>
          <p-select
            [options]="opcoesPeriodicidade"
            [(ngModel)]="form.periodicidade"
            optionLabel="label"
            optionValue="value"
            (onChange)="onDataOrPeriodicidadeChange()"
            styleClass="w-full"
          ></p-select>
        </div>
        <div class="subfield">
          <span class="subfield-label">Data Prevista</span>
          <p-datepicker
            [(ngModel)]="form.proximaData"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            styleClass="w-full"
          ></p-datepicker>
        </div>
      </div>
      <small class="calc-hint">Calculada automaticamente a partir da periodicidade selecionada.</small>
    </div>

    <!-- 8. Bloco de Encaminhamento Automático (se não aprovado) -->
    <div class="encaminhamento-box" *ngIf="form.resultado !== 'Aprovado'">
      <div class="enc-box-header">
        <i class="ri-alert-line"></i>
        <span>Encaminhamento Automático Obrigatório</span>
      </div>
      <p class="enc-box-desc">
        Como o resultado foi <strong>{{ form.resultado }}</strong>, será gerada automaticamente uma entrada no Histórico da arma para acompanhamento técnico.
      </p>

      <div class="form-group mb-2">
        <label class="form-label">Ação / Destino do Encaminhamento</label>
        <p-select
          [options]="opcoesEncaminhamento"
          [(ngModel)]="form.encaminhamento"
          optionLabel="label"
          optionValue="value"
          styleClass="w-full"
        ></p-select>
      </div>

      <label class="enc-checkbox-label">
        <input type="checkbox" [(ngModel)]="form.gerarHistorico" />
        <span>Gerar registo no histórico de acompanhamento da arma</span>
      </label>
    </div>

    <!-- 9. Fotos / Documentos -->
    <div class="form-group uploads-section-group">
      <label class="form-label"><i class="ri-attachment-line"></i> Fotos e Documentos</label>
      <div class="uploads-grid-3">

        <!-- Foto Geral -->
        <div class="upload-slot-card" [class.has-file]="fotoGeralFile">
          <div class="slot-header">
            <i class="ri-camera-line"></i>
            <span>Foto Geral</span>
          </div>
          <div class="slot-preview" *ngIf="fotoGeralPreview">
            <img [src]="fotoGeralPreview" alt="Foto Geral" />
            <button type="button" class="btn-remove-file" (click)="removerFotoGeral()" pTooltip="Remover foto">
              <i class="ri-close-line"></i>
            </button>
          </div>
          <div class="slot-action" *ngIf="!fotoGeralPreview">
            <label class="btn-pick-file">
              <i class="ri-upload-2-line"></i> Carregar
              <input type="file" accept="image/*" (change)="onFotoGeralSelected($event)" hidden />
            </label>
            <span class="slot-hint">Visão geral</span>
          </div>
        </div>

        <!-- Foto de Detalhe -->
        <div class="upload-slot-card" [class.has-file]="fotoDetalheFile">
          <div class="slot-header">
            <i class="ri-zoom-in-line"></i>
            <span>Foto de Detalhe</span>
          </div>
          <div class="slot-preview" *ngIf="fotoDetalhePreview">
            <img [src]="fotoDetalhePreview" alt="Foto Detalhe" />
            <button type="button" class="btn-remove-file" (click)="removerFotoDetalhe()" pTooltip="Remover foto">
              <i class="ri-close-line"></i>
            </button>
          </div>
          <div class="slot-action" *ngIf="!fotoDetalhePreview">
            <label class="btn-pick-file">
              <i class="ri-upload-2-line"></i> Carregar
              <input type="file" accept="image/*" (change)="onFotoDetalheSelected($event)" hidden />
            </label>
            <span class="slot-hint">Numeração / cano</span>
          </div>
        </div>

        <!-- Relatório PDF -->
        <div class="upload-slot-card slot-pdf" [class.has-file]="relatorioPdfFile">
          <div class="slot-header">
            <i class="ri-file-pdf-line"></i>
            <span>Relatório</span>
          </div>
          <div class="slot-file-info" *ngIf="relatorioPdfNome">
            <i class="ri-file-text-line pdf-icon"></i>
            <span class="file-name" [title]="relatorioPdfNome">{{ relatorioPdfNome }}</span>
            <button type="button" class="btn-remove-file" (click)="removerRelatorio()" pTooltip="Remover PDF">
              <i class="ri-close-line"></i>
            </button>
          </div>
          <div class="slot-action" *ngIf="!relatorioPdfNome">
            <label class="btn-pick-file">
              <i class="ri-upload-2-line"></i> Anexar PDF
              <input type="file" accept=".pdf,application/pdf" (change)="onRelatorioSelected($event)" hidden />
            </label>
            <span class="slot-hint">PDF opcional</span>
          </div>
        </div>

      </div>
    </div>

  </div>

  <ng-template #footer>
    <div class="drawer-footer-actions">
      <button type="button" class="btn-secondary" (click)="fecharDrawer()" [disabled]="saving">
        Cancelar
      </button>
      <button type="button" class="btn-primary" (click)="salvarInspecao()" [disabled]="saving">
        <i class="ri-save-line" *ngIf="!saving"></i>
        <i class="ri-loader-4-line ri-spin" *ngIf="saving"></i>
        <span>{{ saving ? 'A guardar...' : 'Guardar Inspeção' }}</span>
      </button>
    </div>
  </ng-template>
</p-drawer>
